import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { ImageModule } from '@df/module-image/image.module';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { IFashionRecommendationsSlideData } from '../fashion-recommendations.interface';
@Component({
    selector: 'fashion-recommendations-slide',
    templateUrl: './fashion-recommendations-slide.component.html',
    standalone: true,
    imports: [ImageModule, TranslationModule],
    styleUrls: ['./fashion-recommendations-slide.component.scss']
})
export class FashionRecommendationsSlideComponent {
    @Input()
    slideData: IFashionRecommendationsSlideData;
    @Input()
    @HostBinding('class.is-active')
    selected: boolean;
    @Output()
    slideSelect = new EventEmitter<void>();
    select(): void {
        this.slideSelect.emit();
    }
}
